



























































































































import { genChip } from '@/utils/componentHelpers';

import app, { AppLink, isDividerLink, NavigationLink } from '@/mixins/app';
import mixins from '@/utils/mixins';
import { mapActions, mapGetters } from 'vuex';
import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError } from '@/models/error/error.types';

import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import ListItem from '@/components/common/ListItem.vue';
import ItemGroup from '@/components/common/Group.vue';

import { IWorkflowFormTemplate, WorkflowFormTemplateStateEnum } from '@/models';

import auth from '@/mixins/auth';

export default mixins(app, auth).extend({
  name: 'drawer',

  components: { ListItem, ItemGroup },

  data() {
    return {
      isUserAppsLoading: false,
      error: null as ISystemError | null
    };
  },

  computed: {
    ...mapGetters({
      iconLogo: 'app/miniCompanyImage',
      textLogo: 'app/lightCompanyImage',
      getWorkflowFormTemplatesWithPublishedRevisions:
        'workflowFormTemplate/getWorkflowFormTemplatesWithPublishedRevisions'
    }),

    userAppLinks(): AppLink[] {
      if (this.getWorkflowFormTemplatesWithPublishedRevisions.length == 0)
        return [];
      else {
        return [
          {
            text: 'Forms',
            icon: 'mdi-text-box-outline',
            to: 'apps',
            color: 'teal darken-3',
            description: 'Manage your user apps here.',
            namespace: 'joma',
            group: 'apps',
            roles: ['Form Submission User', 'Form Admin'],
            children: this.getWorkflowFormTemplatesWithPublishedRevisions.map(
              (template: IWorkflowFormTemplate) =>
                ({
                  text: template.title,
                  description: template.description,
                  icon: 'mdi-text-box-outline',
                  to: 'workflow-form-submission-list',
                  params: { id: template.id! },
                  mandatory_roles: this.userHasRoles(['Form Admin'])
                    ? []
                    : ['Form Submission User'],
                  color: 'primary',
                  namespace: 'joma'
                } as NavigationLink)
            )
          }
        ];
      }
    },

    logo(): string {
      return this.mini ? this.iconLogo : this.textLogo;
    },

    navLinks(): AppLink[] {
      const computedUserAppLinks = this.computeLinks(this.userAppLinks);
      return [
        ...this.computeLinks(this.links),
        ...(computedUserAppLinks.length > 0
          ? [{ divider: true }, ...computedUserAppLinks]
          : [])
      ];
    }
  },

  watch: {
    $route() {
      if (this.drawer && this.$vuetify.breakpoint.mdAndDown)
        this.drawer = false;
    }
  },

  async mounted() {
    await this.loadingCurrentUser();

    this.isUserAppsLoading = true;

    await this.fetchWorkflowFormTemplatesWithPublishedRevisions()
      .catch(error => {
        this.error = setErrorFromAxiosError(error);
      })
      .finally(() => {
        this.isUserAppsLoading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchWorkflowFormTemplatesWithPublishedRevisions:
        'workflowFormTemplate/fetchWorkflowFormTemplatesWithPublishedRevisions'
    }),

    genChip,

    computeLinks(links: AppLink[]) {
      const userGroups: Group[] = this.currentUser.groups ?? [];

      return links.reduce((filteredLinks, link) => {
        if (link.roles && link.roles.length > 0) {
          let userHasRole = userGroups.some(group =>
            link.roles?.includes(group.name!)
          );

          if (
            userHasRole &&
            link.mandatory_roles &&
            link.mandatory_roles?.length > 0
          ) {
            userHasRole = link.mandatory_roles.every(group =>
              userGroups.map(group => group.name!).includes(group)
            );
          }

          if (userHasRole || this.authProvider.isUserAdmin) {
            if (isDividerLink(link)) {
              filteredLinks.push(link);
            } else {
              if (link.children?.length) {
                link.children = this.computeLinks(link.children);
              }
              filteredLinks.push(link);
            }
          }
        } else if (!isDividerLink(link) && link.children?.length) {
          link.children = this.computeLinks(link.children);
          filteredLinks.push(link);
        } else {
          filteredLinks.push(link);
        }
        return filteredLinks;
      }, [] as AppLink[]);
    },

    /** wait for currentuser to load first before resolving */
    loadingCurrentUser(): Promise<void> {
      if (this.currentUser.id) {
        return Promise.resolve();
      }

      return new Promise(resolve => {
        const watcher = this.$watch('currentUser.id', () => {
          resolve();
          watcher();
        });
      });
    }
  }
});
